import { WSForm, WSInputText } from "@wingspanhq/fe-component-library";
import React from "react";
import { IDynamicFieldProps } from "../../types";
import { fieldLabel, isFieldRequired } from "../../utils/fieldRules";

export const DynamicFieldText: React.FC<IDynamicFieldProps> = ({
  field,
  name,
  disabled,
  defaultValue
}) => (
  <WSForm.Field
    name={name}
    defaultValue={defaultValue}
    label={fieldLabel(field)}
    description={field.description ?? field.ui?.helpText}
    component={WSInputText}
    componentProps={{
      placeholder: field.ui?.placeholder ?? field.label,
      disabled,
      required: isFieldRequired(field),
      fsExclude: field.ui?.fsExclude
    }}
  />
);
